import { FormModalContent, FormModalTopBar } from '@upright/ui/common/generic/modals/form-modal/form-modal-parts';
import { useSubscriptionContext } from '../../context';
import { SubscriptionModalBottomBar } from '../../subscription-modal-bottom-bar';
import { CompanyNameInput, EmailInput, FirstNameInput, LastNameInput, MessageInput } from '../inputs/text-inputs';
import { CompanySubscriptionContactFormSuccessPage } from './success-page';

export const CompanySubscriptionContactForm = (props: { hideBackLink?: boolean }) => {
  const context = useSubscriptionContext();
  const [params] = context.params;
  const success = !!params.success;

  const [submitButtonClicked] = context.submitButtonClicked;

  if (success) {
    return <CompanySubscriptionContactFormSuccessPage />;
  }
  return (
    <>
      <FormModalTopBar>
        <h1>Request a demo with our experts</h1>
      </FormModalTopBar>
      <FormModalContent>
        <div className={'subscriptionForm'}>
          <section>
            <p>Please leave your contact information here, and we will be in touch during the next business day.</p>
          </section>
          <section id={'inputs'}>
            <FirstNameInput {...{ submitButtonClicked }} />
            <LastNameInput {...{ submitButtonClicked }} />
            <EmailInput {...{ submitButtonClicked }} />
            <CompanyNameInput {...{ submitButtonClicked }} />
            <MessageInput />
          </section>
        </div>
      </FormModalContent>
      <SubscriptionModalBottomBar hideBackLink={props.hideBackLink} />
    </>
  );
};
